/*
 * @Author: 周泽林 759005093@qq.com
 * @Date: 2025-12-03 09:24:15
 * @LastEditors: 周泽林 759005093@qq.com
 * @LastEditTime: 2025-12-04 15:34:43
 * @FilePath: \lcsc-ecp-nextjs-shopping-guide\apps\nextjs-list-app\src\apis\ListApi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { doPost, doGet } from '@lcsc-ui/utils/request';

import { baseURL, env } from '@/utils/baseUrl';

let listServe = '/lcsc-list';
if (env === 'local') {
  listServe = 'https://dev-mock.szlcsc.com';
}

const ListApi = {
  category: `${listServe}/category`, // 新版list 类目页列表接口
  brand: `${listServe}/brand/product`, // 新版list 品牌详情页列表接口
  oversea: `${listServe}/oversea`,
  hotkeyword: `/hot/keyword/list`,
  icDetail: `${listServe}/ic/detail`,
  icRecommend: `${listServe}/ic/recommend`,
  hotKeywordNear: `${env === 'fat' ? 'https://list.szlcsc.com' : listServe}/hot/keyword/near`,
  searchPanJiT: `${listServe}/panjit`,
  hotData: `${listServe}/hot/data`,
  newProduct: `${listServe}/new/product`, // 新品专区列表接口
  activityLt: `${listServe}/activity/lt`,
  activityLtShort: `${listServe}/activity/lt/short/link`,
  ptAd: `${listServe}/pintuan/advert`,
  hotList: `${listServe}/hot/list`,
  discountList: `${listServe}/zk{activityId}/page`,
  hotKeywordList: `${env === 'fat' ? 'https://list.szlcsc.com' : listServe}/hot/keyword/list`,
};

export default ListApi;

export function getParameterSelect(body) {
  return doPost(baseURL, '/parameter', body);
}

// 类目页客户端二次查询
export function secondQueryCatalog(body) {
  return doPost(baseURL, '/category/product', body, {
    timeout: 30000,
  });
}
// mro 类目页客户端二次查询

export function secondQueryMroCatalog(body) {
  return doPost(baseURL, '/mro/category/product', body);
}

// 类目页欢迎纠错
export function insertFilterCorrection(formData) {
  return doPost('lcscSearchUrl', '/insertFilterCorrectionV2', formData);
}

// 品牌详情页客户端二次查询
export function secondQueryBrand(query) {
  return doGet(baseURL, '/brand/product', query);
}

// mro 品牌详情页客户端二次查询

export function secondQueryMroBrand(query) {
  return doGet(baseURL, '/mro/brand/product', query);
}

// 新品列表查询（客户端二次查询）
export function secondQueryNewProduct(body) {
  // 将普通对象转换为 FormData 格式
  const formData = new FormData();
  Object.keys(body).forEach((key) => {
    if (body[key] !== undefined && body[key] !== null) {
      formData.append(key, body[key]);
    }
  });
  return doPost(baseURL, '/new/product', formData);
}
// 海外现货客户端二次查询
export function secondQueryOversea(query) {
  return doGet(baseURL, '/oversea_page', query);
}
// 立推列表页客户端二次查询
export function secondQueryLtProduct(body) {
  return doPost(baseURL, '/activity/lt/product', body);
}

// 立推短链列表页客户端二次查询
export function secondQueryLtShortProduct(body) {
  return doPost(baseURL, '/activity/lt/short/link/product', body);
}

// 爆款列表页客户端二次查询
export function secondQueryHotProduct(body) {
  return doPost(baseURL, '/hot/list/product', body);
}

export function secondQueryDiscountProduct(body) {
  return doPost(baseURL, `/zk${body?.activityUrl}/product`, body);
}
